/**
 * Static content for the login island.
 *
 * Everything in this file is a compile-time constant on purpose. /login is
 * anonymous and must paint with ZERO network dependency, so nothing here may
 * ever become an API call.
 */

/**
 * The two authentication methods, and only two.
 *
 * The mockup showed three DESTINATION tiles (Command Centre / Response Team /
 * Field Worker). Those are reconciled away deliberately: the requirement
 * mandates exactly two login METHODS, and role selection happens AFTER sign-in
 * in the header dropdown, from the roles the server says the user holds. A
 * pre-auth role picker would be both a lie (the user does not choose their
 * role) and an enumeration hint. The tiles keep the mockup's visual treatment
 * and change what they select.
 */
export type LoginMethod = 'password' | 'otp';

export interface LoginMethodTile {
  readonly id: LoginMethod;
  /** Two-line mono micro-caps label, as in the mockup. */
  readonly line1: string;
  readonly line2: string;
}

export const LOGIN_METHOD_TILES: readonly LoginMethodTile[] = [
  { id: 'password', line1: 'PASSWORD', line2: 'EMAIL OR ID' },
  { id: 'otp', line1: 'PHONE OTP', line2: 'ONE-TIME CODE' },
];

/** Left-panel narrative and the two footers. */
export const LOGIN_COPY = {
  markTop: 'CORE',
  markBottom: 'EHS',
  markSub: 'EMERGENCY MANAGEMENT',

  /** Two lines, set as a display headline. */
  headlineLine1: 'Command clarity',
  headlineLine2: 'when minutes matter.',

  body:
    'Incident controllers, response teams and site personnel work from one ' +
    "shared picture — who's safe, who isn't, and what happens next.",

  siteLine: 'PLANT 04 · WEST BLOCK · IST',
  gatePassLabel: 'Gate-pass sync',
  gatePassState: 'live',
  referenceLine: 'ISO 45001 · IEC 61508 REF',

  signInHeading: 'SIGN IN',
  signInSub: 'PLANT 04 · WEST BLOCK',

  rightFooter: 'Authorised personnel only · all sessions are logged',
} as const;
